const tRPProjectAssignments = "pages.company_account_profile.tables.project_assignments";
const tRPDependents = "pages.company_account_profile.tables.employees_dependents";
const tRPEmployeesToUsers = "pages.company_account_profile.tables.employees_to_users";
const tRPUserParams = "components.user_params";

export const SIGN_OFFS_PAGE_SIZE = 5;

export const getWidth = (fieldTitle: string, columns: ColumnsType[]): number => {
  const field = columns.find((obj) => obj.field === fieldTitle);

  if (field) return field.width;

  return 0;
};

type ColumnsType = {
  title: string;
  field: string;
  width: number;
};

export const projectAssignmentColumns = [
  {
    title: `${tRPProjectAssignments}.fields.project`,
    field: "project",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.start_date`,
    field: "start",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.end_date`,
    field: "end",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.visible_to_clients`,
    field: "makeVisibleToClients",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.require_accept_by_client_absence`,
    field: "requireAcceptByClientAbsence",
    width: 10,
  },

  {
    title: `${tRPProjectAssignments}.fields.require_accept_by_client_extrHrs`,
    field: "requireAcceptByClientExtrHrs",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.require_accept_by_client_expenses`,
    field: "requireAcceptByClientExpenses",
    width: 10,
  },
  {
    title: `${tRPProjectAssignments}.fields.clientApprovers`,
    field: "clientApprovers",
    width: 10,
  },
  {
    title: "",
    field: "actions",
    width: 0,
  },
];

export const dependentsColumns = [
  {
    title: `${tRPDependents}.fields.dependent_type`,
    field: "dependentType",
    width: 25,
  },
  {
    title: "common_words.name",
    field: "name",
    width: 25,
  },
  {
    title: `${tRPDependents}.fields.birth_date`,
    field: "birthDate",
    width: 25,
  },
  {
    title: `${tRPDependents}.fields.to_date`,
    field: "toDate",
    width: 25,
  },
  {
    title: "",
    field: "actions",
    width: 0,
  },
];

export const employeeAccessToSystemColumns = [
  {
    title: `${tRPEmployeesToUsers}.fields.user`,
    field: "user",
    width: 25,
  },
  {
    title: `${tRPEmployeesToUsers}.fields.last_user_login`,
    field: "lastUserLogin",
    width: 35,
  },
  {
    title: `${tRPEmployeesToUsers}.fields.to_date`,
    field: "toDate",
    width: 20,
  },
  {
    title: `${tRPUserParams}.two_factor_auth_method`,
    field: "userParams",
    width: 20,
  },
  {
    title: "",
    field: "actions",
    width: 0,
  },
];

export const employeeAbsencesColumns = [
  {
    title: "Absence type",
    field: "absenceType",
    width: 20,
  },
  {
    title: "From date",
    field: "fromDate",
    width: 20,
  },
  {
    title: "To date",
    field: "toDate",
    width: 20,
  },
  {
    title: "Accepted | Rejected",
    field: "isApproved, isRejected",
    width: 20,
  },
  {
    title: "Accepted | Rejected (by client)",
    field: "acceptedByClient, rejectedByClient",
    width: 20,
  },
];
